export enum DataChangeTypeEnum {
    NoChange = 1,
    New = 2,
    Update = 3,
    Delete = 4,
}
